module.exports = __webpack_public_path__ + "static/media/wardah_brand_banner_2.36f9a2c6.jpg";